// @flow
import { DESTINATIONS } from 'Client/cms/toolkit/constants';
import { DestinationsLine } from 'Components/lines/destinations-line/DestinationsLine';
import { destinationsResolver } from './destinations.resolver';

export const destinationsDescriptor = {
  name: DESTINATIONS,
  component: DestinationsLine,
  resolver: destinationsResolver.resolve,
};
